import React, {FC, useMemo} from 'react';
import styled from 'styled-components';

import {AppPanelId, makeInboxesPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {BannersHost} from '../../../../libs/shared/ui/src/components/banners/bannersHost';
import {maxLeftPanelWidth} from '../../../../libs/shared/ui/src/components/leftPanel/leftPanelHelpers';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {AppState} from '../../../store/appState';
import {
  makeGetInboxesIsEditingWorkspaces,
  makeGetInboxesPanelOptional,
} from '../../../store/panels/inboxes/inboxesPanelSelectors';

/*
 * Props.
 */

interface AppBannersHostProps {
  className?: string;
  panelId: AppPanelId;
}

/*
 * Constants.
 */

const bannersPadding = 15;

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  height: 100%;
  padding: ${bannersPadding}px;
  display: flex;
  pointer-events: none;
`;

/*
 * Component.
 */

export const AppBannersHost: FC<AppBannersHostProps> = (props) => {
  const {panelId} = props;

  const inboxesPanelId = makeInboxesPanelId(panelId);

  const getIsEditingWorkspaces = useMemo(() => {
    const getInboxesIsEditingWorkspaces = makeGetInboxesIsEditingWorkspaces();
    const getInboxesPanelOptional = makeGetInboxesPanelOptional();

    return (state: AppState) => {
      const panel = getInboxesPanelOptional(state, {panelId: inboxesPanelId});
      // If the panel doesn't exist or is not of the inboxes type, we are not in edit node and can return early.
      if (!panel) {
        return false;
      }

      const isEditingWorkspaces = getInboxesIsEditingWorkspaces(state, {
        panelId: inboxesPanelId,
      });
      return isEditingWorkspaces;
    };
  }, [inboxesPanelId]);

  const isEditingWorkspaces = useAppSelector((state: AppState) => getIsEditingWorkspaces(state));

  // When in P1 edit mode, do not show any banners at all.
  if (isEditingWorkspaces) {
    return null;
  }

  return (
    <StyledWrapperDiv className={props.className}>
      <BannersHost width={maxLeftPanelWidth - bannersPadding * 2} />
    </StyledWrapperDiv>
  );
};
